import type { GridColumn } from '../column/column.types.ts'
import type { GridCellKey } from '../cell/cell.types.ts'

import _keyBy from 'lodash/keyBy'

import { useAtomValue } from 'jotai'
import { columnsAtom, getCueCellsAtom } from '@/store/rundown.store.ts'
import {
  useColumnLayoutColumns,
  useEffectiveHiddenColumns,
} from '@/shared/store/column-layout.store.ts'

import { useGetAllowedColumns } from '@/entities/rundown'

import { useCueState } from './CueContext'
import { Cell } from '../cell/Cell.tsx'
import { CellContextProvider } from '../cell/CellContext'

import { useRundownSnap } from '../rundown-page.store.ts'

export function CueCellList() {
  const { getAllowedColumns } = useGetAllowedColumns()

  const { cue } = useCueState()

  const getCueCells = useAtomValue(getCueCellsAtom)
  const cells = getCueCells(cue.id)

  const { id: rundownId } = useRundownSnap()

  const baseColumns = useAtomValue(columnsAtom)
  const columns = useColumnLayoutColumns(rundownId, baseColumns)
  const hiddenColumns = useEffectiveHiddenColumns(rundownId)

  const cellColMap = _keyBy(cells, 'columnId')

  const cellArray = getAllowedColumns(columns)
    .filter((column) => !hiddenColumns.includes(column.id))
    .map((col) => ({ col, cell: cellColMap[col.id] }))

  return cellArray.map(({ col, cell }) => {
    const cellKey: GridCellKey = `cell_${cue.id}_${col.id}`

    return (
      <CellContextProvider
        key={cellKey}
        cellKey={cellKey}
        cell={cell}
        col={col as GridColumn}
      >
        <Cell />
      </CellContextProvider>
    )
  })
}
